import { datadogLogs } from '@datadog/browser-logs';

export const initDDLogs = () => {
  if (typeof window === 'undefined') {
    return;
  }

  datadogLogs.init({
    clientToken: 'pub25f8001b653129913556274aba5ca97c',
    site: 'datadoghq.com',
    service: 'cardfinder',
    forwardErrorsToLogs: false,
    forwardConsoleLogs: 'all',
    sessionSampleRate: 100,
    env: process.env.NEXT_PUBLIC_DEPLOYABLE_ENV,
  });
};
